<template>
	<div>
		<el-dialog
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:visible.sync="finalVisible"
				:title="form.isOrdered === 1 ? '纠错下单' : '纠错报价'"
				width="70%">
			<div class="dialog-container">
				<!-- 左侧座位图部分 -->
				<div class="left-section">
					<el-image
							:preview-src-list="[form.imgUrl]"
							:src="form.imgUrl"
							alt="原图"
							fit="cover"
							height="auto"
							width="50"
					/>
				</div>

				<!-- 右侧输入表单部分 -->
				<div class="right-section">
					<el-form :model="form" label-position="left" label-width="100px">
						<el-form-item label="城市">
							<!-- 城市下拉搜索 -->
							<el-select
									v-model="form.cityName"
									:filter-method="filterCity"
									clearable
									filterable
									placeholder="请输入城市名称"
									style="width: 100%"
									@change="onCityChange"
									@clear="onCityClear"
							>
								<el-option
										v-for="city in filteredCities"
										:key="city.cityId"
										:label="city.regionName"
										:value="city.regionName"
								>
									<span>{{ city.regionName }} ({{ city.pinYin }})</span>
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="影院">
							<!-- 影院实时搜索 -->
							<el-autocomplete
									v-model="form.cinemaName"
									:fetch-suggestions="getCinemaSuggestions"
									placeholder="请输入影院名称"
									style="width: 100%"
									@select="onCinemaSelect"
							>
								<template slot-scope="{ item }">
									<div class="name">{{ item.cinemaName }}</div>
									<span class="addr">{{ item.address ? `(${item.address})` : '' }}</span>
								</template>
							</el-autocomplete>
						</el-form-item>

						<el-form-item label="影片">
							<!-- 影片实时搜索 -->
							<el-select
									v-model="form.movieName"
									:filter-method="filterFilm"
									clearable
									filterable
									placeholder="请输入影片名称"
									style="width: 100%"
									@change="onMovieChange"
							>
								<el-option
										v-for="film in filteredFilms"
										:key="film.showId"
										:label="film.showName"
										:value="film.showName"
								>
									<span>{{ film.showName }}</span>
								</el-option>
							</el-select>
						</el-form-item>

						<!-- 时间选择器 -->
						<el-form-item label="场次">
							<el-date-picker
									v-model="form.showTime"
									format="yyyy-MM-dd HH:mm:ss"
									placeholder="选择时间"
									style="width: 100%"
									type="datetime"
									value-format="yyyy-MM-dd HH:mm:ss"
									@change="onShowTimeChange"
							/>
							<div v-if="countdown && form.showTime" class="countdown">
								距离开场时间: {{ countdown }}
							</div>
						</el-form-item>

						<el-form-item label="影厅">
							<el-input v-model="form.hallName" placeholder="请输入影厅"></el-input>
						</el-form-item>

						<el-form-item label="座位">
							<el-input v-model="form.seat" placeholder="n排n座，多个用逗号或中文逗号隔开"
												@input="calculateOrderNum"></el-input>
						</el-form-item>

						<el-form-item label="座位数量">
							<el-input v-model="form.orderNum" :disabled="true"></el-input>
						</el-form-item>

						<el-form-item label="是否可调座">
							<el-radio-group v-model="form.acceptChangeSeat">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<div>
							<dl>
								<dt>其他信息</dt>
								<dd>旺旺对接客服：{{ form.serviceNickName }}</dd>
								<dd>淘宝店：{{ form.tbShopName }}</dd>
								<dd>下单用户：{{ form.userNickName }}</dd>
                <dd v-if="form.isOrdered" style="color: red;">淘宝订单号：{{ form.tbOrderId }} <el-button v-if="form.tbOrderId" @click="handleCopyId(form.tbOrderId)" icon="el-icon-document-copy" type="text">复制</el-button></dd>
                <dd v-if="form.isOrdered" style="color: red;">支付金额：{{ (form.orderPrice / 100).toFixed(2) }}元</dd>
							</dl>
              <div v-if="form.isOrdered && isOrderedError" class="isOrderedError">{{ isOrderedError }}</div>
						</div>
						<!-- 错误信息显示 -->
						<el-alert
								v-if="!isSubmitting && errorMessage"
								:description="errorMessage"
								closable
								show-icon
								title="警告"
								type="error"
								@close="errorMessage = ''"
						/>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="danger" @click="handleError">无法下单，关闭</el-button>
            <el-button v-if='form.isOrdered' :disabled="isSubmitting" :loading="isSubmitting" type="primary" @click="submitOrderReporting">
              获取报价并下单
            </el-button>
						<el-button v-else :disabled="isSubmitting" :loading="isSubmitting" type="primary" @click="submitOrder">
							获取报备并给用户推送下单卡片
						</el-button>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 关闭订单的弹窗 -->
		<taobao-order-error-close-dialog
				v-if="form.id"
				:id="form.id"
				:visible.sync="closeDialogVisible"
        :isOrdered="form.isOrdered"
				@confirm-close="handleOrderClose"
				@close-success="refreshData"
		/>
	</div>
</template>

<script>
import TaobaoOrderErrorCloseDialog from './taobaoOrderErrorCloseDialog.vue'; // 引入关闭订单弹窗
import mini from "@/api/mini"; // 引入 MiniModel

const MiniModel = new mini();

export default {
	name: 'TaobaoOrderErrorDialog',
	components: {
		TaobaoOrderErrorCloseDialog, // 注册关闭订单弹窗组件
	},
	props: {
		formData: {
			type: Object,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		finalVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			}
		}
	},
	data() {
		return {
			form: {...this.formData},
			errorMessage: '', // 错误信息
			closeDialogVisible: false, // 控制关闭订单弹窗的显示状态
			cities: [], // 存储城市列表
			cinemas: [], // 存储影院列表
			films: [], // 存储影片列表
			filteredCities: [],
			filteredCinemas: [],
			filteredFilms: [],
			selectedCityId: null, // 当前选中的城市ID
			countdown: '', // 倒计时
			intervalId: null, // 定时器 ID
			isSubmitting: false, // 控制按钮loading状态
      isOrderedError:'',
		};
	},
	watch: {
		formData: {
			immediate: true,
			handler(newFormData) {
				this.form = {...newFormData};
				this.startCountdown();
				this.errorMessage = '';
				this.selectedCityId = null;
				this.filteredCinemas = [];
				this.filteredFilms = [];
				this.filteredCities = [...this.cities];
        this.isOrderedError = '';
			}
		}
	},
	mounted() {
		this.loadCityList(); // 加载城市列表
	},
	methods: {
		// 影院实时搜索建议
		getCinemaSuggestions(queryString, callback) {
			if (!queryString) {
				return callback([]);
			}

			const params = {
				cityId: this.selectedCityId || '',
				cinemaName: queryString
			};

			MiniModel.taobaoOcrCinemaList(params).then(res => {
				if (res.data.code === 200) {
					const cinemas = res.data.data;
					callback(cinemas);
				} else {
					this.$message.error(res.data.info);
					callback([]);
				}
			});
		},

		// 处理影院选择后的逻辑
		onCinemaSelect(cinema) {
			this.form.cinemaName = cinema.cinemaName;
			this.checkForSchedule(); // 选择影院后，检查是否可以获取影厅
		},
		// 根据座位数量自动计算订单数量
		calculateOrderNum() {
			if (this.form.seat) {
				const seatsArray = this.form.seat.split(/[,，]/); // 通过中英文逗号进行分割
				this.form.orderNum = seatsArray.filter(seat => seat.trim() !== '').length; // 去除空白项，计算数量
			} else {
				this.form.orderNum = 0;
			}
		},
		onMovieChange() {
			this.checkForSchedule(); // 当影片变化时，检查是否可以获取影厅
		},
		onShowTimeChange() {
			this.checkForSchedule(); // 当场次变化时，检查是否可以获取影厅
			this.startCountdown()	// 开始倒计时
		},
		// 检查是否满足条件，请求影厅信息
		async checkForSchedule() {
			if (this.form.cinemaName && this.form.movieName && this.form.showTime) {
				try {
					const response = await MiniModel.taoBaoOcrScheduleList({
						cinemaName: this.form.cinemaName,
						filmName: this.form.movieName,
						showTime: this.form.showTime
					});

					if (response.data && response.data.code === 200) {
						const halls = response.data.data;
						if (halls.length === 1) {
							// 自动填入影厅
							this.form.hallName = halls[0].hallName;
						} else if (halls.length > 1) {
							// 多个影厅，保持影厅为空，让客服手动填写
							this.form.hallName = '';
						}
					} else {
						this.errorMessage = response.data.message || '无法获取影厅信息';
					}
				} catch (error) {
					this.errorMessage = '请求失败，请重试';
				}
			}
		},
		refreshData() {
			this.closeDialogVisible = false;
			this.$emit('update:visible', false); // 关闭弹窗
			this.$emit('refreshData'); // 触发外部的刷新事件
		},
		handleError() {
			// 打开关闭订单弹窗
			this.closeDialogVisible = true;
		},
    async submitOrderReporting() {
      this.isSubmitting = true;
      await new Promise(resolve => setTimeout(resolve, 1000));
      try{
        console.log(this.form,'this.form===submitOrderReporting')
        // return
        const res = await MiniModel.taobaoOcrRatePrice({
          ...this.form
        })
        console.log(res,'res===submitOrderReporting')
        if(res.data.code !== 200) {
          this.isOrderedError = res.data.message
          return;
        }
        this.$message.success(res.data.message);
        this.refreshData();
      }finally {
        this.isSubmitting = false;
      }
    },
		async submitOrder() {
			this.isSubmitting = true; // 开始loading
			// 休息1秒
			await new Promise(resolve => setTimeout(resolve, 1000));
			const data = {
				acceptChangeSeat: this.form.acceptChangeSeat,
				cinemaName: this.form.cinemaName,
				cityName: this.form.cityName,
				hallName: this.form.hallName,
				id: this.form.id,
				movieName: this.form.movieName,
				seat: this.form.seat,
				showTime: this.form.showTime
			};

			try {
				const response = await MiniModel.taobaoOcrPushOrder(data);

				if (response.data && response.data.code === 200) {
					this.$message.success('订单已成功推送');
					// this.$emit('update:visible', false);
					this.refreshData();
				} else {
					this.errorMessage = response.data.message || '推送订单失败';
				}
			} catch (error) {
				this.errorMessage = '请求失败，请重试';
			} finally {
				this.isSubmitting = false; // 请求完成后结束loading
			}
		},
		handleOrderClose(data) {
			this.$message.success('订单已成功关闭');
			this.closeDialogVisible = false;
		},
		loadCityList() {
			MiniModel.taobaoOcrCityList().then(res => {
				if (res.data.code === 200) {
					this.cities = res.data.data;
					this.filteredCities = this.cities;
				} else {
					this.$message.error(res.data.info);
				}
			});
		},
		filterCity(query) {
			if (query) {
				this.filteredCities = this.cities.filter(city =>
						city.regionName.includes(query) || city.pinYin.toLowerCase().includes(query.toLowerCase())
				);
			} else {
				this.filteredCities = this.cities;
			}
		},
		onCityChange(cityName) {
			const selectedCity = this.cities.find(city => city.regionName === cityName);
			if (selectedCity) {
				this.selectedCityId = selectedCity.cityId;
			}
		},
		onCityClear() {
			this.selectedCityId = null;
			this.filteredCinemas = [];
			this.filteredCities = [...this.cities]
		},
		filterCinema(query) {
			if (!query) {
				return;
			}
			const params = {
				cityId: this.selectedCityId || '',
				cinemaName: query
			};
			MiniModel.taobaoOcrCinemaList(params).then(res => {
				if (res.data.code === 200) {
					this.cinemas = res.data.data;
					this.filteredCinemas = this.cinemas;
				} else {
					this.$message.error(res.data.info);
				}
			});
		},
		filterFilm(query) {
			if (query) {
				MiniModel.taobaoOcrFilmList({filmName: query}).then(res => {
					if (res.data.code === 200) {
						this.films = res.data.data;
						this.filteredFilms = this.films;
					} else {
						this.$message.error(res.data.info);
					}
				});
			}
		},
		startCountdown() {
			if (this.intervalId) {
				clearInterval(this.intervalId);
			}
			if (!this.form.showTime) {
				this.countdown = '';
				return;
			}

			const showTime = new Date(this.form.showTime).getTime();

			this.intervalId = setInterval(() => {
				const now = new Date().getTime();
				const timeDiff = showTime - now;

				if (timeDiff <= 0) {
					this.countdown = '已开场';
					clearInterval(this.intervalId);
				} else {
					const hours = Math.floor(timeDiff / (1000 * 60 * 60));
					const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
					this.countdown = `${hours}小时${minutes}分钟`;
				}
			}, 1000);
		},
    handleCopyId(inquiryId) {
      if(!inquiryId) {
        this.$message.error('淘宝订单号为空');
        return;
      }
      // 创建一个临时的 textarea 用于复制文本
      const tempInput = document.createElement('textarea');
      tempInput.value = inquiryId;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('淘宝订单号已复制');
    },
	},
	beforeDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	},
};
</script>

<style scoped>
.dialog-container {
	display: flex;
}

.left-section {
	width: 25%;
	padding: 20px;
}

.seat-map {
	width: 100%;
	height: auto;
}

.right-section {
	width: 75%;
	padding: 20px;
}

.dialog-footer {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.countdown {
	margin-top: 10px;
	color: red;
}
.isOrderedError{
  background: #fdf3f4;
  padding: 6px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/components/taobaoOrderErrorDialog.vue